import * as type from './constant';

export const getAbsence = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getAbsenceSuccess = (payload, selfRole = '') => ({
  type: type.GET_SUCCESS,
  payload,
  selfRole,
});

export const getAbsenceError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addAbsence = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addAbsenceSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateAbsence = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateAbsenceSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteAbsence = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteAbsenceSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationAbsenceError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
